/**
 * Only a same-site path may be returned to after signing in (`/login?redirect=…`). Browsers read
 * `/\evil.com` as `//evil.com` and drop tabs and newlines inside URLs, so a plain
 * `startsWith('/')` check is not enough: the path must resolve to this origin.
 */
export function safeRedirect(r: unknown, origin = 'https://app.invalid'): string | undefined {
  if (typeof r !== 'string' || !r.startsWith('/') || /[\\\s]/.test(r)) return undefined;
  if (r.startsWith('//')) return undefined;
  try {
    return new URL(r, origin).origin === origin ? r : undefined;
  } catch {
    return undefined;
  }
}
